export default __webpack_public_path__ + "static/media/mindmap_emotions.c8b4bfab.png";